import logger from "@/composables/logger"
import { router } from "@/routes"
import type { Message } from "@/types/notification"
import { useBaseAPIGet, type TrailsRespPaged } from "@xy-planning-network/trees"
import { computed, type ComputedRef } from "vue"

interface UseAppMessagesCount {
  count: ComputedRef<number>
  refresh: () => void
}

const currentUserId = window.InitialVueProps?.initialProps?.currentUser?.id || 0
const { hasFetched, isLoading, execute, result } = useBaseAPIGet<
  TrailsRespPaged<Message>
>(router.UserMessages({ id: currentUserId }))

// NOTE(spk): fetch does not return a promise,
// avoid making duplicate concurrent requests.
const fetch = () => {
  if (isLoading.value) {
    return
  }

  execute(
    {
      page: 1,
      perPage: 10,
      read: false,
      sort: "created_at",
      sortDir: "DESC",
    },
    { skipLoader: true }
  ).catch((error) => {
    logger.report(`Failed to fetch the unread messages count.`, {
      error: error,
      userId: currentUserId,
    })
    return
  })
}

/**
 * useAppMessagsCount fetches the initial count of unread messges for the
 * global current user and exposes a refresh method for updating the count.
 *
 * @returns UseAppMessagesCount
 */
export default (): UseAppMessagesCount => {
  if (!hasFetched.value) {
    fetch()
  }

  return {
    count: computed(() => result.value?.data?.totalItems || 0),
    refresh: fetch,
  }
}
